<template>
  <div class="page page-links container is-fluid">
    <div class="container container-inner">
      <div class="columns is-gapless is-multiline">

        <div class="column content is-hidden-tablet" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true" v-if="linksdata">
          <img :src="linksdata.image ? linksdata.image.path : ''" class="img-responsive" />
        </div>

        <div class="column content content-main is-right" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="linksdata">
          <div class="title">
            {{ linksdata.title }}
          </div>
          <markdown v-if="linksdata.content" :source="linksdata.content" style="margin-bottom:30px;" />
          <p v-for="(link, index) in links" :key="`${index}`">
            <a :href="link.link" target="_blank">
              {{ link.title }} <i class="fa fa-external-link"></i>
            </a>
          </p>
          <!-- <div class="text">
            This information provided by CMS is for general purposes only to assist you in successful completion of conditions of probation. CMS nor any representative or employee is authorized to specify a particular Risk Reduction Program, Clinical Evaluator or Treatment Center  a probationer shall attend. All information is provided in good faith.  We make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information. Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site.
            <br /><br />
            <ul class="list" style="list-style:none;margin-left:0;">
              <li class="font-bold text-uppercase"><a class="link" href="https://www.aa.org/" target="_blank">Alcoholics Anonymous</a></li>
              <li class="font-bold text-uppercase"><a class="link" href="https://gaduiintervention.dbhdd.ga.gov/" target="_blank">Clinical Evaluations/Treatment Providers</a></li>
              <li class="font-bold text-uppercase"><a class="link" href="https://dds.georgia.gov/duirisk-reduction-information" target="_blank">DUI Schools/Risk Reduction</a></li>
              <li class="font-bold text-uppercase"><a class="link" href="https://dbhdd.georgia.gov/" target="_blank">Georgia Department of Behavioral Health</a></li>
              <li class="font-bold text-uppercase"><a class="link" href="https://dds.georgia.gov/" target="_blank">Georgia Department of Driver Services</a></li>
            </ul>
          </div> -->
        </div>

        <div class="column content" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true" v-if="linksdata">
          <img :src="linksdata.image ? linksdata.image.path : ''" class="img-responsive is-hidden-mobile" />
          <!-- <div class="box color-gray-lighter-bg" v-if="false">
            <div class="subtitle" style="margin-bottom:0.8em;">
              Collection and Probation Services
            </div>
            <div class="text">
              For those in need of a Spanish speaking representative we have an associate available for you. Para aquellos que necesiten un representante que hable español tenemos un representante  disponible para asistirlo.
            </div>
          </div> -->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Markdown from 'vue-markdown'
import EventBus from '@/controllers/EventBus'

import Site from '@/apis/Site'

export default {
  name: 'page-links',
  components: {
    Markdown
  },
  data () {
    return {
      isDesktop: true,
      linksdata: undefined,
      links: undefined
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.getLinksData()
    this.getLinks()
  },
  methods: {
    async getLinksData () {
      try {
        let data
        // linksdata
        this.linksdata = undefined
        data = await Site.aboutNamed('links')
        if (data && data[0]) {
          data = data[0]
          this.linksdata = data
        }
      } catch (error) {
        console.log('links error', error)
      }
    },

    async getLinks () {
      try {
        let data
        // links
        this.links = undefined
        data = await Site.hotlinkNameLike('external-link')
        if (data) {
          this.links = data
        }
      } catch (error) {
        console.log('links error', error)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";
@import "../styles/page.scss";

.page-links {
  .content {
    ul.list {
      li {
        margin-top: 15px;
      }
    }

    p:nth-child(2) {
      margin-top: 30px;
    }

    a {
      // text-decoration: underline;
      color: $color-primary-blue;
      font-size: 1.0em;
      font-weight: bold;

      .fa {
        margin-left: 6px;
        font-size: 0.6em;
        vertical-align: middle;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Links.vue?0ed27eb6